<template>
  <div class="tracking-bar"
      :class="{ disabled: disabled }"
      @mouseenter.stop="$emit('onMouseEnter')"
      @mouseleave.stop="$emit('onMouseLeave')"
      @click.stop="!disabled && $emit('onClick')">
    <div class="tracking-bar-wrap">
      <div class="tracking-bar-text">
        <div class="session-info member">
          <p class="session-info-label" v-html="$t('tracking.user.member')"></p>
          <p>{{ member | letterMillion(0) }}</p>
        </div>
        <div class="session-info login">
          <p class="session-info-label" v-html="$t('tracking.user.logging')"></p>
          <p>{{ login | letterMillion(0) }}</p>
        </div>
        <div class="session-info new">
          <p class="session-info-label" v-html="$t('tracking.user.login')"></p>
          <p>{{ newLogin | letterMillion(0) }}</p>
        </div>
      </div>
      <div class="tracking-bar-chart">
        <div class="bar-wrap">
          <div class="member-box" v-if="!disabled && ratio.member > 0" :style="{ width: `${ratio.member * 100}%` }">
            <div class="over-hidden-wrap">
              <span class="session-ratio"><i class="icon icon--tracking-member"></i>{{ ratio.member * 100 | fixed(1) }}%</span>
              <div class="login-box current" v-if="ratio.login > 0" :style="{ width: `${ratio.login / ratio.member * 100}%` }">
                <div class="over-hidden-wrap">
                  <span class="session-ratio" v-if="ratio.login > 0"><i class="icon icon--tracking-login"></i>{{ ratio.login * 100 | fixed(1) }}%</span>
                  <div class="login-box new" v-if="ratio.newLogin > 0" :style="{ width: `${ratio.newLogin / ratio.login * 100}%` }">
                    <div class="over-hidden-wrap">
                      <span class="session-ratio" v-if="ratio.newLogin > 0"><i class="icon icon--tracking-login-new"></i>{{ ratio.newLogin * 100 | fixed(1) }}%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrackingBar',
  props: {
    total: {
      type: Number,
      required: false,
      default: 0
    },
    member: {
      type: Number,
      required: false,
      default: 0
    },
    login: {
      type: Number,
      required: false,
      default: 0
    },
    newLogin: {
      type: Number,
      required: false,
      default: 0
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ratio () {
      return {
        member: this.member / this.total,
        login: this.login / this.total,
        newLogin: this.newLogin / this.total
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.tracking-bar {
  position: absolute;
  left: 50%;
  bottom: -2px;
  transform: translate(-50%, 100%);
  width: 100%;
  padding-bottom: 20px;
  &.disabled {
    filter: grayscale(100%);
  }
  &-wrap {
    position: relative;
    width: 100%;
    max-height: 20px;
    padding: 3px;
    border-radius: 10px;
    background-color: #FFF;
    box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    overflow: hidden;
    transition: all 0.4s ease;

    .tracking-bar-text {
      display: flex;
      gap: 9px;
      padding: 5px 6px 32px;

      .session-info {
        position: relative;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 4px;
        color: var(--Color-Brand-b500_o, #EC0047);
        font-size: 11px;
        font-weight: 600;
        &.member {
          color: $brandColor;
        }
        &.login {
          color: #FF708A;
        }
        &.new {
          color: #AC0033;
          text-align: end;
        }
        &-label {
          line-height: 1.2;
        }
        &:not(:last-child)::before {
          content: "";
          position: absolute;
          top: 1px;
          right: -5px;
          display: block;
          width: 1px;
          height: calc(100% - 2px);
          background-color: #E0E0E0;
        }
      }
    }

    .tracking-bar-chart {
      position: absolute;
      bottom: 3px;
      width: calc(100% - 6px);
      padding: 2px;
      border: 1px solid #2BC0D9;
      border-radius: 100px;
      background-color: #FFF;
      box-sizing: border-box;
      box-shadow: 0 0 0 3px #ffffff;
      & > * {
        transition: all 0.2s ease;
      }

      .bar-wrap {
        position: relative;
        width: 100%;
        height: 8px;
        border-radius: 100px;
        background-color: #B2E9F3;
        overflow: hidden;

        .member-box {
          height: 100%;
          padding: 0 1px;
          border: 1px solid #00000014;
          border-top-left-radius: 100px;
          border-bottom-left-radius: 100px;
          background-color: $brandColor;
          box-shadow: 0px 1px 4px 0px #00000033 inset;
          box-sizing: border-box;
          font-size: 9px;
          font-weight: 600;
          color: #FFEBEE;
          .over-hidden-wrap {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            position: relative;
            width: 100%;
            height: 100%;
            overflow: hidden;
            border-radius: 1px;
          }
          .session-ratio {
            display: flex;
            align-items: center;
            gap: 2px;
            opacity: 0;
            position: absolute;
            top: 50%;
            left: 1px;
            transform: translateY(-50%);
          }
          .login-box {
            @include flexYcenter;
            height: 100%;
            box-sizing: border-box;
            z-index: 1;
            &.current {
              padding: 2px;
              border-radius: 2px;
              border: 1px solid #ad0134;
              background-color: #FB9798;
            }
            &.new {
              border-radius: 1px;
              background-color: #8D002A;
              .session-ratio {
                left: 3px;
              }
            }
            .session-ratio {
              color: #FFF;
              text-shadow: 0px 1px 1px 0px #000;
            }
          }
        }
      }
    }
  }
  &:hover:not(.disabled) {
    .tracking-bar-wrap {
      max-height: 100px;
      border-radius: 8px;
      .tracking-bar-text {
      }
      .tracking-bar-chart {
        border-radius: 5px;
        .bar-wrap {
          border-radius: 2px;
          height: 22px;
          .member-box {
            padding: 1px;
            border-top-left-radius: 2px;
            border-bottom-left-radius: 2px;
            .session-ratio {
              opacity: 1;
            }
            .login-box {
            }
          }
        }
      }
    }
  }
}
</style>
